import { shaApprovalText, type ShaApprovalState, type ShaApprovalView } from '@wodi/shared';
import { Tag, type TagState } from '@wodi/ui';

// The SHA approval gate as a tag, in the shared words (docs/plans/phase1-sha.md §9.3):
// outlined while something is still owed (asking, waiting, declined, list missing, override),
// filled wash once SHA approved. Never the danger colour: this is not clinical danger.

export const SHAPE: Record<ShaApprovalState, TagState> = {
  not_required: 'done',
  requirement_unknown: 'pending',
  needs_request: 'attention',
  request_failed: 'failed',
  waiting: 'attention',
  approved: 'done',
  declined: 'failed',
  overridden: 'pending',
};

/** Nothing on a visit SHA doesn't pay for, or for a service SHA needn't approve. */
export function ShaApprovalTag({ approval }: { approval: ShaApprovalView | null }) {
  if (approval === null || approval.state === 'not_required') return null;
  return <Tag state={SHAPE[approval.state]}>{shaApprovalText(approval)}</Tag>;
}

/** Whether the gate is held by SHA approval rather than by payment or price. */
export function heldBySha(approval: ShaApprovalView | null): boolean {
  return (
    approval !== null &&
    ['needs_request', 'request_failed', 'waiting', 'declined'].includes(approval.state)
  );
}
